<template>
	<Dialog v-bind:value="value" @input="$emit('input', $event)"
					title="Position löschen ?"
					@ok="submit" ok-text="Fortfahren" :loading="loading"
					@cancel="cancel">
		Soll die Position <b>{{ positionName }}</b>
		wirklich gelöscht werden?
	</Dialog>
</template>

<script>
import Dialog from "../../../components/Dialog";

export default {
	name: "DeletePositionDialog",
	components: {Dialog},
	props: ['value', 'position'],
	data: () => {
		return {
			name: null,
			loading: false,
		}
	},
	computed: {
		positionName() {
			return this.position ? this.position.name : null;
		},
		vuexState() {
			return this.$store.state.zones;
		},
		selectedSite() {
			return this.$store.state.display.selectedSite;
		},
		selectedType() {
			return this.$store.state.display.selectedType;
		},
	},
	methods: {
		async submit() {
			this.loading = true;
			let data = await this.$store.dispatch('zones/deletePosition', this.getBody());
			this.loading = false;
			if (data.Status) {
				this.$root.$emit('snackbar', 'Position ' + this.positionName + ' erfolgreich gelöscht.')
				this.$emit('input', false);
			}
		},
		getBody() {
			return {
				publisher_id: this.selectedSite.PublisherId,
				site_id: this.selectedSite.SiteId,
				type_id: this.selectedType.SitetypeId,
				zone_id: this.vuexState.zoneDetails.Zone.ZoneId,
				position_id: this.position.PositionId,
			}
		},
		cancel() {
			if (this.loading) {
				this.$store.commit('zones/cancelRequest', 'deletePosition');
				this.loading = false;
			}
			this.close();
		},
		close() {
			this.$emit('input', false); // set v-model to false -> close dialog
		}
	},
}
</script>

<style scoped>

</style>